// src/components/sections/ServicesCards.js
import React from "react";
import { Link } from "react-router-dom";
import { FaClock, FaCheckCircle, FaUsers } from "react-icons/fa";
import deliveryImg from "../../Assets/Images/deliveryImg.png";
import qualityWork from "../../Assets/Images/qualityWork - Copy.jpg";
import ProfessionalTeamImg from "../../Assets/Images/professionalTeams - Copy.jpg";

const ServicesCards = () => {
  const services = [
    {
      title: "On Time Delivery",
      desc: "We ensure your projects are delivered on time, every time. Our team works efficiently without compromising quality.",
      img: deliveryImg,
      icon: <FaClock />,
      delay: 0,
    },
    {
      title: "Quality Works",
      desc: "We deliver high-quality solutions that exceed expectations with precision, innovation, and attention to detail.",
      img: qualityWork,
      icon: <FaCheckCircle />,
      delay: 100,
    },
    {
      title: "Professional Teams",
      desc: "Our expert team ensures seamless execution and outstanding results from concept to completion.",
      img: ProfessionalTeamImg,
      icon: <FaUsers />,
      delay: 200,
    },
  ];

  return (
    <section className="max-w-7xl mx-auto px-4 py-16">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
        {services.map((item, index) => (
          <div
            key={index}
            data-aos="fade-up"
            data-aos-delay={item.delay}
            className="group relative bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-3"
          >
            {/* Image */}
            <div className="relative overflow-hidden">
              <img
                src={item.img}
                alt={item.title}
                className="h-56 w-full object-cover transition-transform duration-700 group-hover:scale-110"
              />

              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>

              {/* Icon Badge */}
              <div className="absolute bottom-4 left-4 w-12 h-12 flex items-center justify-center rounded-full  text-white text-xl shadow-lg backdrop-blur-xl">
                {item.icon}
              </div>
            </div>

            {/* Content */}
            <div className="p-6 text-left">
              <h3 className="text-2xl font-semibold text-white mb-3 group-hover:text-blue-400 transition-colors duration-300">
                {item.title}
              </h3>
              <p className="text-gray-300 text-sm leading-relaxed">
                {item.desc}
              </p>

              {/* Read More */}
              <Link
                to="/aboutUs"
                className="mt-4 inline-block text-sm font-medium text-blue-400 hover:text-blue-300 transition-all"
              >
                Learn More →
              </Link>
            </div>

            {/* Glow Effect */}
            <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition duration-500 pointer-events-none bg-gradient-to-r from-blue-500/10 via-purple-500/10 to-pink-500/10"></div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServicesCards;
